module.exports = __webpack_public_path__ + "static/WEDDING E&M-139-98d35fb9ec0882043c18106d38eb9000.jpg";